<template>
  <div class="chatMain">
    <el-container slot="container" class="full-height">
      <!-- 左侧侧边栏 -->
      <el-aside width="320px" class="aside-box">
        <el-container class="full-height" direction="vertical">
          <!-- 搜索栏 -->
          <el-header height="60px" class="header">
            <div class="from-search">
              <el-input
                  v-model="input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索聊天 / 好友 / 群组"
                  size="small"
              />
            </div>
          </el-header>
          <!-- 对话列表栏 -->
          <el-scrollbar
              tag="section"
              ref="menusScrollbar"
              class="full-height"
              :native="false"
          >
            <el-main class="main">
              <p v-show="loadStatus == 2" class="empty-data">
                <i class="el-icon-loading" /> 数据加载中...
              </p>

              <p v-show="loadStatus == 3 && talkItems == 0" class="empty-data">
                暂无聊天消息
              </p>

              <p v-show="loadStatus == 3 && talkNum > 0" class="main-menu">
                <span class="title">消息记录 ({{ talkNum }})</span>
              </p>

              <!-- <p v-show="loadStatus == 4" style="text-align:center;">数据加载失败，请点击重试！</p> -->

              <!-- 对话列表 -->
              <template v-if="loadStatus == 3">
                <div
                    v-for="item in talkItems"
                    :key="item.accountId"
                    class="talk-item pointer"
                    :class="{ active: index_name == item.accountId }"
                    @click="clickTab(item.accountId)"
                    @contextmenu.prevent="talkItemsMenu(item, $event)"
                >
                  <div class="avatar-box">
                    <img
                        v-show="!item.avatar"
                        :src="detaultAvatar"
                    />
                    <img
                        v-show="item.avatar"
                        :src="item.avatar"
                        :onerror="detaultAvatar"
                    />
<!--                    <div-->
<!--                        v-show="item.is_top == 0"-->
<!--                        class="top-mask"-->
<!--                        @click.stop="topChatItem(item)"-->
<!--                    >-->
<!--                      <i class="el-icon-top" />-->
<!--                    </div>-->
                  </div>
                  <div class="card-box">
                    <div class="title">
                      <div class="card-name">
                        <p class="nickname">
                          {{
                            item.nickname
                          }}
                        </p>
<!--                        <div v-show="item.unread_num" class="larkc-tag">-->
<!--                          {{ item.unread_num }}条未读-->
<!--                        </div>-->
<!--                        <div-->
<!--                            v-show="item.is_disturb"-->
<!--                            class="larkc-tag disturb"-->
<!--                        >-->
<!--                          <i class="iconfont icon-xiaoximiandarao" />-->
<!--                        </div>-->
                      </div>
                      <div class="card-time">
                        <u-time :value="item.lastTime" />
                      </div>
                    </div>
                    <div class="content">
                      <template
                          v-if="
                            index_name != item.accountId && item.draft_text
                          "
                      >
                        <span class="draft-color">[草稿]</span>
                        <span>{{ item.draft_text }}</span>
                      </template>
                      <template v-else>
<!--                        <template v-if="item.is_robot == 0">-->
<!--                            <span-->
<!--                                v-if="item.talk_type == 1"-->
<!--                                :class="{ 'online-color': item.is_online == 1 }"-->
<!--                            >-->
<!--                              [{{ item.is_online == 1 ? '在线' : '离线' }}]-->
<!--                            </span>-->
<!--                          <span v-else>[群消息]</span>-->
<!--                        </template>-->

                        <span>{{ item.content }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </el-main>
          </el-scrollbar>
        </el-container>
      </el-aside>

      <!-- 聊天面板容器 -->
      <el-main class="ov-hidden full-height no-padding">
        <WelcomeModule v-if="index_name == null" />
        <TalkPanel
            v-else
            class="full-height"
            :params="params"
            :is-online="isFriendOnline()"
            @change-talk="changeTalk"
            @close-talk="closeTalk"
        />
      </el-main>
    </el-container>

  </div>
</template>
<script>
import MainLayout from './MainLayout'
import WelcomeModule from '@/components/layout/WelcomeModule'

import TalkPanel from '@/components/chat/panel/TalkPanel'

import UTime from './utime'

import { beautifyTime } from '@/utils/functions'
import { findTalkIndex, getCacheIndexName } from '@/utils/talk'
import {
  humanChatList
} from '@/api/demo/helper'

const detaultAvatar = require('@/assets/image/detault-avatar.jpg')
const title = document.title

export default {
  name: 'helperHuman',
  components: {
    MainLayout,
    TalkPanel,
    WelcomeModule,
    UTime
  },
  data () {
    return {
      detaultAvatar: detaultAvatar,
      loadStatus: 3,
      talkNum: 0,
      index_name: '',
      unreadNum: 0,
      talkItems: [],
      talks: [],
      subHeaderShadow: false,
      launchGroupShow: false,

      // 对话面板的传递参数
      params: {
        talk_type: 0,
        receiver_id: 0,
        nickname: ''
      },

      // 查询关键词
      input: '',

      // header 工具菜单
      subMenu: false,

      // 消息未读数计时器
      interval: null
    }
  },
  computed: {

  },
  watch: {
  },

  beforeRouteUpdate (to, from, next) {
  },
  created () {
  },
  mounted () {
    this.scrollEvent()
    this.getTalkItems()
  },
  destroyed () {
    document.title = title
    clearInterval(this.interval)
    this.clearTalk()
  },
  methods: {

    getTalkItems () {
      let that = this
      humanChatList().then(data => {
        console.log('getTalkItems', data)
        that.talkItems = data
      })
    },
    // 美化时间格式
    beautifyTime,

    // header 功能栏隐藏事件
    closeSubMenu () {
      this.subMenu = false
    },
    // 当前对话好友在线状态
    isFriendOnline () {
      // let index = findTalkIndex(this.index_name)
      return true
    },
    // 清除当前对话
    clearTalk () {
      this.params = {
        talk_type: 0,
        receiver_id: 0,
        nickname: ''
      }
    },

    // 工具栏事件
    triggerSubMenu (type) {
      this.closeSubMenu()

      if (type == 1) {
        this.launchGroupShow = true
      } else {
        this.$refs.searchUsers.open()
      }
    },

    // 监听自定义滚动条事件
    scrollEvent () {
      let scrollbarEl = this.$refs.menusScrollbar.wrap
      scrollbarEl.onscroll = () => {
        this.subHeaderShadow = scrollbarEl.scrollTop > 0
      }
    },

    // 发起群聊成功后回调方法
    groupChatSuccess (data) {
      this.launchGroupShow = false
      sessionStorage.setItem('send_message_index_name', `2_${data.group_id}`)
      this.$store.dispatch('LOAD_TALK_ITEMS')
    },

    // 切换聊天栏目
    clickTab (accountId) {
      let index = this.findTalkIndex(accountId)

      if (index == -1) return

      let item = this.talkItems[index]

      let nickname = item.nickname
      //
      this.params = {
        talk_type: 1,
        accountId,
        nickname,
        is_robot: 0
      }
      console.log('[params]', this.params)

      // this.$store.commit('UPDATE_DIALOGUE_MESSAGE', {
      //   talk_type: 1,
      //   receiver_id: accountId,
      //   is_robot:0,
      // })
    },
    findTalkIndex (accountId) {
      return this.talkItems.findIndex(
        item => item.accountId == accountId
      )
    },
    // 修改当前对话
    changeTalk (index_name) {
      sessionStorage.setItem('send_message_index_name', index_name)
      this.$store.dispatch('LOAD_TALK_ITEMS')
    },

    // 关闭当前对话及刷新对话列表
    closeTalk () {
      this.$store.commit('UPDATE_DIALOGUE_MESSAGE', {
        talk_type: 0,
        receiver_id: 0,
        is_robot: 0
      })

      this.$store.dispatch('LOAD_TALK_ITEMS')
    },

    // 对话列表的右键自定义菜单
    talkItemsMenu (item, event) {
      let items = {
        items: [
          {
            label: '好友信息',
            icon: 'el-icon-user',
            disabled: item.talk_type == 2 || item.is_robot == 1,
            onClick: () => {
              this.$user(item.receiver_id)
            }
          },
          {
            label: '修改备注',
            icon: 'el-icon-edit-outline',
            disabled: item.talk_type == 2 || item.is_robot == 1,
            onClick: () => {
              this.editFriendRemarks(item)
            }
          },
          {
            label: item.is_top == 0 ? '会话置顶' : '取消置顶',
            icon: 'el-icon-top',
            onClick: () => {
              this.topChatItem(item)
            }
          },
          {
            label: item.is_disturb == 0 ? '消息免打扰' : '开启消息提示',
            icon:
              item.is_disturb == 0
                ? 'el-icon-close-notification'
                : 'el-icon-bell',
            disabled: item.is_robot == 1,
            onClick: () => {
              this.setNotDisturb(item)
            }
          },
          {
            label: '移除会话',
            icon: 'el-icon-remove-outline',
            divided: true,
            onClick: () => {
              this.delChatItem(item)
            }
          },
          {
            label: item.talk_type == 1 ? '删除好友' : '退出群聊',
            icon: 'el-icon-delete',
            disabled: item.is_robot == 1,
            onClick: () => {
              let title = item.talk_type == 1 ? '删除好友' : '退出群聊'
              this.$confirm(
                `此操作将 <span style="color:red;font-size:16px;">${title}</span>, 是否继续?`,
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                  center: true,
                  dangerouslyUseHTMLString: true
                }
              ).then(() => {
                if (item.talk_type == 1) {
                  this.removeFriend(item)
                } else {
                  this.removeGroup(item)
                }
              })
            }
          }
        ],
        event: event,
        zIndex: 3
      }

      this.$contextmenu(items)
      return false
    },

    // 置顶栏右键菜单栏
    topItemsMenu (item, event) {
      this.$contextmenu({
        items: [
          {
            label: item.is_top == 0 ? '会话置顶' : '取消置顶',
            icon: 'el-icon-top',
            onClick: () => {
              this.topChatItem(item)
            }
          }
        ],
        event: event,
        zIndex: 3
      })

      return false
    },

    // 会话列表置顶
    topChatItem (item) {
      ServeTopTalkList({
        list_id: item.id,
        type: item.is_top == 0 ? 1 : 2
      }).then(({ code }) => {
        if (code == 200) {
          this.$store.commit('UPDATE_TALK_ITEM', {
            index_name: item.index_name,
            is_top: item.is_top == 0 ? 1 : 0
          })
        }
      })
    },

    // 移除会话列表
    delChatItem (item) {
      ServeDeleteTalkList({
        list_id: item.id
      }).then(({ code }) => {
        if (code == 200) {
          this.clearTalk()
          this.$store.commit('REMOVE_TALK_ITEM', item.index_name)
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}

.chatMain{
  height: 100vh;
  background-color: #fff;
}

.aside-box {
  position: relative;
  border-right: 1px solid rgb(245, 245, 245);
  overflow: hidden;
  padding: 0;
  transition: width 0.3s;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 15px;

    .from-search {
      flex: 1 1;
      flex-shrink: 0;

      /deep/ .el-input .el-input__inner {
        border-radius: 20px;
      }
    }

    .tools {
      flex-basis: 32px;
      flex-shrink: 0;
      height: 32px;
      margin-left: 15px;
      cursor: pointer;
      text-align: center;
      position: relative;
      user-select: none;

      .tools-menu {
        position: absolute;
        right: 0;
        top: 38px;
        width: 100px;
        min-height: 80px;
        box-sizing: border-box;
        background-color: rgba(31, 35, 41, 0.9);
        border-radius: 5px;
        z-index: 1;
        padding: 3px 0;

        .menu-item {
          height: 40px;
          line-height: 40px;
          color: white;
          font-size: 14px;

          &:hover {
            background-color: rgba(70, 72, 73, 0.9);
          }
        }
      }
    }
  }

  .subheader {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px 8px;
    overflow: hidden;
    flex-shrink: 0;
    justify-content: flex-start;
    background: aliceblue;

    .top-item {
      flex-basis: 41px;
      flex-shrink: 0;
      height: 50px;
      margin: 3px 0 3px 2px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .avatar {
        flex-basis: 32px;
        width: 32px;
        height: 32px;
        background-color: #508afe;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: white;
        flex-shrink: 0;
        overflow: hidden;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          background-color: white;
        }
      }

      .name {
        font-size: 12px;
        text-align: center;
        color: #8f959e;
        transform: scale(0.84);
        text-align: center;
        line-height: 20px;
        word-break: break-all;
        overflow: hidden;

        &.active {
          color: #508afe;
        }
      }
    }

    &.shadow {
      box-shadow: 0 2px 6px 0 rgba(31, 35, 41, 0.05);
    }
  }
}

.aside-box .main {
  overflow: hidden;
  padding: 0;

  .empty-data {
    text-align: center;
    padding-top: 40px;
    color: #ccc;
  }

  .main-menu {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 10px 6px 10px;
    align-items: center;
    user-select: none;

    .title {
      font-size: 12px;
      font-weight: 600;
      color: #1f2329;
    }

    .icon {
      cursor: pointer;
    }
  }

  .talk-item {
    padding: 8px 10px;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-left: 3px solid transparent;
    transition: 0.2s ease-in;

    .avatar-box {
      height: 35px;
      width: 35px;
      flex-shrink: 0;
      background-color: #508afe;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: white;
      user-select: none;
      transition: ease 1s;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        background-color: white;
        border-radius: 3px;
      }

      .top-mask {
        width: 100%;
        height: 100%;
        background-color: rgba(22, 25, 29, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        color: white;
        display: none;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }

      &:hover .top-mask {
        display: flex;
      }
    }

    .card-box {
      height: 40px;
      display: flex;
      align-content: center;
      flex-direction: column;
      flex: 1 1;
      margin-left: 10px;
      overflow: hidden;

      .title {
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;

        .card-name {
          color: #1f2329;
          font-size: 14px;
          line-height: 20px;
          flex: 1 1;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          align-items: center;
          overflow: hidden;

          .nickname {
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 3px;
          }

          .top {
            color: #dc9b04 !important;
            background-color: #faf1d1 !important;
          }

          .group {
            color: #3370ff !important;
            background-color: #e1eaff !important;
            font-size: 13px;
          }

          .disturb {
            color: #98999c !important;
            background-color: #ecedf1 !important;
            i {
              font-size: 12px;
            }
          }
        }
      }

      .card-time {
        color: #8f959e;
        font-size: 12px;
        margin-left: 10px;
        user-select: none;
      }

      .content {
        font-size: 13px;
        line-height: 18px;
        color: #8f959e;
        margin-top: 3px;
        font-weight: 300;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        span:first-child {
          margin-right: 5px;
        }

        .online-color {
          color: #4aa71c;
          font-weight: 300;
        }

        .draft-color {
          color: red;
          font-weight: 300;
        }
      }
    }

    &:hover {
      background-color: #eff0f1;
    }

    &.active {
      .avatar-box {
        border-radius: 5px;
      }

      background-color: #eff0f1;
    }
  }
}

@media screen and (max-width: 800px) {
  .aside-box {
    width: 220px !important;

    .subheader {
      display: none;
    }

    .card-box .larkc-tag {
      display: none;
    }
  }
}
</style>
